"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INNERMOST_GAUGE_RADIUS = exports.LEGEND_ALIGNMENT = exports.SIZES = exports.ACTIVITY_GUAGE_CHART_COLORS = void 0;
var design_system_colors_1 = require("../../../../style/theme/design-system-colors");
exports.ACTIVITY_GUAGE_CHART_COLORS = [
    design_system_colors_1.DesignSystemColor.Violet.LIGHT_2,
    design_system_colors_1.DesignSystemColor.Teal.LIGHT_1,
    design_system_colors_1.DesignSystemColor.Blue.LIGHT_1,
    design_system_colors_1.DesignSystemColor.Blue.LIGHT_3,
    design_system_colors_1.DesignSystemColor.Pink.LIGHT_1,
    design_system_colors_1.DesignSystemColor.Red.LIGHT_2,
    design_system_colors_1.DesignSystemColor.Yellow.LIGHT_3,
    design_system_colors_1.DesignSystemColor.Pink.LIGHT_2,
    design_system_colors_1.DesignSystemColor.Violet.LIGHT_3,
    design_system_colors_1.DesignSystemColor.Green.LIGHT_3,
];
exports.SIZES = {
    xs: 300,
    s: 360,
    md: 420,
    lg: 480,
};
exports.LEGEND_ALIGNMENT = {
    horizontal: 'horizontal',
    vertical: 'vertical',
};
exports.INNERMOST_GAUGE_RADIUS = 40;
